import { UserRole, type User } from '@/model/user/schema'

type Viewer = Pick<User, 'role' | 'is_allow_dashboard'> | null | undefined

// 認証APIが社内ドメイン・閲覧権限を照合した結果を使う。
export const canViewDashboard = (user: Viewer): boolean =>
  user?.is_allow_dashboard === true

export const canViewAppDashboard = (user: Viewer): boolean =>
  canViewDashboard(user) && user?.role === UserRole.systemAdmin
